export type MessageType = 'success' | 'error' | 'warning' | 'info' | 'loading';

export interface MessageHandler {
  show: (type: MessageType, content: string, duration?: number) => void;
}

let handler: MessageHandler | null = null;

export function setMessageHandler(h: MessageHandler | null) {
  handler = h;
}

function invoke(type: MessageType, content: string, duration?: number) {
  if (handler) {
    handler.show(type, content, duration);
  } else if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(`[ui/message] ${type}:`, content);
  }
}

function makeMethod(type: MessageType) {
  return (content: string, duration?: number) => invoke(type, content, duration);
}

export const message = {
  success: makeMethod('success'),
  error: makeMethod('error'),
  warning: makeMethod('warning'),
  info: makeMethod('info'),
  loading: makeMethod('loading'),
};

export default message;
